import { gql } from "@apollo/client";

import TopicNodeFragment from "./topic-node-fragment";

export default gql`
  ${TopicNodeFragment}
  mutation addPreviousMeetingTopicsToCurrentMeetingMutation($meetingId: Int!) {
    addPreviousMeetingTopicsToCurrentMeeting(meetingId: $meetingId) {
      meeting {
        id
        undiscussedPreviousMeetingTopics {
          id
          title
        }
        topics {
          edges {
            node {
              ...TopicNodeNewPageFragment
            }
          }
        }
      }
    }
  }
`;
